import React, { useContext } from 'react';
import { ReactComponent as VerificadoIcon } from '../../assets/IconsColurs/IconsGeneral/verificado.svg';
import { ReactComponent as EsperaIcon } from '../../assets/IconsColurs/IconsGeneral/espera.svg';
import { ReactComponent as FallidoIcon } from '../../assets/IconsColurs/IconsGeneral/fallido.svg';

import { GLOBAL_LANGUAGE } from "../../language/language";
import { UtilContext } from '../../context/UtilContext';

const StatusVerification = ({ status = 1 }) => {

  const { language } = useContext(UtilContext);
  const t = GLOBAL_LANGUAGE[language] || GLOBAL_LANGUAGE.es;

  const statusConfig = {
    1: {
      icon: <EsperaIcon className="w-5 h-5 text-[#D6A561]" />,
      title: t.status_verification.pending.title,
      description: t.status_verification.pending.description,
    },
    2: {
      icon: <FallidoIcon className="w-5 h-5 text-[#DC3545]" />,
      title: t.status_verification.failed.title,
      description: t.status_verification.failed.description,
    },
    3: {
      icon: <FallidoIcon className="w-5 h-5 text-[#DC3545]" />,
      title: t.status_verification.failed.title,
      description: t.status_verification.failed.description,
    },
    4: {
      icon: <FallidoIcon className="w-5 h-5 text-[#DC3545]" />,
      title: t.status_verification.failed.title,
      description: t.status_verification.failed.description,
    },
    5: {
      icon: <VerificadoIcon className="w-5 h-5 text-[#28A745]" />,
      title: t.status_verification.verified.title,
      description: t.status_verification.verified.description,
    },
  };

  // Configuración predeterminada
  const defaultConfig = {
    icon: null,
    title: t.status_verification.unknown.title,
    description: t.status_verification.unknown.description,
  };

  // Usamos la configuración basada en el `status` o la predeterminada
  const { icon, title, description } = statusConfig[status] || defaultConfig;

  return (
    <div className="flex flex-col p-4 rounded-lg bg-[#5E5E6329] text-[#8A8A8E]">
      <div className="flex items-center gap-2">
        {icon}
        <p className="text-white font-semibold">{title}</p>
      </div>
      <p className="text-sm text-[#8A8A8E]">
        {description}
      </p>
    </div>
  );
};



export default StatusVerification;
